import Typography from 'typography'
import fairyGatesTheme from 'typography-theme-fairy-gates'

fairyGatesTheme.googleFonts = []
fairyGatesTheme.bodyFontFamily[1] = 'sans-serif'

fairyGatesTheme.overrideThemeStyles = ({ rhythm }, options) => ({
    a: {
      color: '#1897f9',
      textShadow: 'none',
      backgroundImage: ''
    }
  })

const typography = new Typography(fairyGatesTheme)

export default typography


// WEBPACK FOOTER //
// ./src/utils/typography.js